<template>
  <div id="page-entity-toba-details">
    <company-toba-form
        v-if="model"
        ref="form"
        v-model="model"
        :loading="loading"
        card-title="Create TOBA"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'company.tobas.list'})"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="create"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import NotificationMixin from '@/components/mixins/NotificationMixin';
import CompanyTobaForm from './CompanyTobaForm';
import PageTitle from "@/views/components/extra-components/layout/PageTitle";
import CardPage from '@/views/components/Views/CardPage';

export default {
  name: 'FacilityEdit',
  components: {
    CompanyTobaForm,
    PageTitle,
    CardPage,
  },
  mixins: [SaveModelMixin, NotificationMixin],
  data() {
    return {
      loading: false,
      model: {},
    };
  },
  computed: {
    id() {
      return this.$route.params.tobaId;
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    getParams() {
      const data = this.getModelCopy(true);
      data.Company_FK = this.$route.params.id;

      const references = [
        'TOBAType_FK',
        'status',
      ];

      const dates = [
        'StartDate',
        'ExpiryDate',
      ];

      this.setDates(dates, data);
      this.setReferences(references, data);
      delete data.tobas;

      return data;
    },
    async create() {
      if (!this.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      try {
        const {data} = await this.$api.companyToba.create(params);
        this.notifySuccess('TOBA created');
        this.$router.back();
      } catch (e) {
        this.notifyError('TOBA failed to be updated');
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
